module.exports = __webpack_public_path__ + "static/media/matilde-cap-brazil-thinking.2b795b53.png";